module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block",
    class: _vm.templateClass
  }, [_c('div', {
    ref: "contentBackground",
    staticClass: "content-block--background"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block--content"
  }, [_c('div', {
    staticClass: "content-block--title"
  }, [(this.item.title != undefined) ? _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(this.item.title))]) : _vm._e(), _vm._v(" "), (this.item.subTitle != undefined) ? _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(this.item.subTitle))]) : _vm._e(), _vm._v(" "), (this.item.underTitle != undefined) ? _c('h4', {
    staticClass: "under-title"
  }, [_vm._v(_vm._s(this.item.underTitle))]) : _vm._e()]), _vm._v(" "), (this.item.videoUrl != undefined) ? _c('div', {
    ref: "playButton",
    staticClass: "content-block--play",
    on: {
      "click": _vm.toggleVideo
    }
  }, [_c('div', {
    ref: "playCircle",
    staticClass: "content-block--play--circle"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/images/play.png",
      "alt": "play button"
    }
  })]) : _vm._e(), _vm._v(" "), (this.item.slider != undefined) ? _c('div', {
    ref: "slider",
    staticClass: "content-block--slider"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-block--slider--next",
    on: {
      "click": _vm.slideRight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block--slider--prev",
    on: {
      "click": _vm.slideLeft
    }
  })]) : _vm._e(), _vm._v(" "), (this.item.awards != undefined) ? _c('div', {
    staticClass: "content-block--awards"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-block--footer"
  }, [(this.item.footerTop != undefined) ? _c('p', {
    staticClass: "content-block--client"
  }, [_vm._v("\n                " + _vm._s(this.item.footerTop) + "\n            ")]) : _vm._e(), _vm._v(" "), (this.item.footerBottom != undefined) ? _c('p', {
    staticClass: "content-block--credits"
  }, [_vm._v("\n                " + _vm._s(this.item.footerBottom) + "\n            ")]) : _vm._e()]), _vm._v(" "), (this.item.clients != undefined) ? _c('div', {
    staticClass: "content-block--clients",
    domProps: {
      "innerHTML": _vm._s(this.item.clients)
    }
  }) : _vm._e(), _vm._v(" "), (this.item.teaser != undefined) ? _c('div', {
    staticClass: "content-block--teaser"
  }, [_c('h2', {
    staticClass: "teaser"
  }, [_vm._v(_vm._s(this.item.teaser))]), _vm._v(" "), _c('h3', {
    staticClass: "under-teaser"
  }, [_vm._v(_vm._s(this.item.underTeaser))])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "videoBlock",
    staticClass: "content-block--video",
    on: {
      "click": _vm.toggleVideo
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content-block--video--container"
  }, [_c('div', {
    ref: "videoWrapper",
    staticClass: "wrapper"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-block--more",
    on: {
      "click": _vm.moveDown
    }
  }, [_vm._v("\n            More work\n            "), _vm._m(4)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block--slider--container"
  }, [_c('ul', {
    staticClass: "content-block--slider--wrapper"
  }, [_c('li', {
    staticClass: "content-block--slide"
  }, [_c('img', {
    attrs: {
      "src": "static/images/slide-1.jpg",
      "alt": "slider image"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "content-block--slide"
  }, [_c('img', {
    attrs: {
      "src": "static/images/slide-2.jpg",
      "alt": "slider image"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "content-block--slide"
  }, [_c('img', {
    attrs: {
      "src": "static/images/slide-3.jpg",
      "alt": "slider image"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "content-block--slide"
  }, [_c('img', {
    attrs: {
      "src": "static/images/slide-4.jpg",
      "alt": "slider image"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block--awards--left"
  }, [_vm._v("\n                Recent awards for our work"), _c('br'), _vm._v("\n                with the Ministry of Defence\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block--awards--right"
  }, [_c('img', {
    attrs: {
      "src": "static/images/awards.png",
      "srcset": "static/images/awards@2x.png 2x",
      "alt": "awards"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block--video--close"
  }, [_c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "static/images/arrow-down.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09bad808!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentBlock.vue
// module id = 14
// module chunks = 1